import React, { Component } from 'react';
import logo from '../../logo.svg';
import {NavLink} from 'react-router-dom';
class Header extends Component {
  render() {
    return (
      <div className="zmz-react-header">
        <div className="zmz-react-header__box">
          <div className="zmz-react-header__left">
            <a href="#/bug"><img src={logo} className="zmz-react-logo" alt=""/></a>
          </div>
          <div className="zmz-react-header__right">
            <button className="zmz-react-button"><span>=</span></button>
            <div className="zmz-react-nav">
              <ul className="zmz-nav__demo">
                <li className="nav-item"><NavLink exact to='/' className="blue">canvas</NavLink></li>
                <li className="nav-item"><NavLink  to='/game' className="blue">game</NavLink></li>
                <li className="nav-item"><NavLink  to='/Demo' className="blue">在线json格式化</NavLink></li>
                <li className="nav-item"><NavLink  to='/Demo2' className="blue">在线编码解码工具</NavLink></li>
                <li className="nav-item"><NavLink  to='/Demo4' className="blue">拖拽</NavLink></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default Header;
